'use strict';

import { ViewChildren, QueryList } from '@angular/core';

import { RedocComponent, BaseComponent, SchemaManager } from '../base';
import JsonPointer from '../../utils/JsonPointer';
import { Tabs, Tab } from '../../shared/components/index';
import { SchemaSample } from '../SchemaSample/schema-sample';
import { PrismPipe } from '../../utils/pipes';
import { RedocEventsService } from '../../services/index';

@RedocComponent({
  selector: 'request-samples',
  template: `
    <header *ngIf="data.schemaPointer || data.samples.length"> Request samples </header>
    <schema-sample *ngIf="!data.samples.length" [pointer]="data.schemaPointer"> </schema-sample>
    <tabs *ngIf="data.samples.length" (change)=changeLangNotify($event)>
      <tab tabTitle="JSON">
        <schema-sample [pointer]="data.schemaPointer"> </schema-sample>
      </tab>
      <tab *ngFor="let sample of data.samples" [tabTitle]="sample.lang">
        <pre innerHtml="{{sample.source | prism:sample.lang}}"></pre>
      </tab>
    </tabs>
  `,
  styles: [`
    header{font-family:Montserrat;font-size:0.929em;text-transform:uppercase;margin:0;color:#9fb4be;text-transform:uppercase;font-weight:normal}:host>tabs>ul li{font-family:Montserrat;font-size:.9em;border-radius:2px;margin:2px 0;padding:3px 10px 2px 10px;line-height:1.25;color:#9fb4be}:host>tabs>ul li:hover{background-color:rgba(255,255,255,0.1);color:#ffffff}:host>tabs>ul li.active{background-color:#ffffff;color:#263238}:host tabs ul{padding-top:10px}pre{overflow-x:auto;word-break:break-all;word-wrap:break-word;white-space:pre-wrap}
  `],
  directives: [SchemaSample, Tabs, Tab],
  inputs: ['schemaPointer'],
  pipes: [PrismPipe]
})
@Reflect.metadata('parameters', [[SchemaManager], [RedocEventsService], [new ViewChildren(Tabs), QueryList]])
export class RequestSamples extends BaseComponent {
  constructor(schemaMgr, events, childQuery) {
    super(schemaMgr);
    childQuery.changes.subscribe(() => {
      this.childTabs = childQuery.first;
    });
    this.events = events;
  }

  init() {
    this.subscribeForEvents();
  }

  changeLangNotify(lang) {
    this.events.samplesLanguageChanged.next(lang);
  }

  subscribeForEvents() {
    this.events.samplesLanguageChanged.subscribe((sampleLang) => {
      if (!this.childTabs) return;
      this.childTabs.selectyByTitle(sampleLang);
    });
  }

  prepareModel() {
    this.data = {};
    this.data.schemaPointer = JsonPointer.join(this.schemaPointer, 'schema');
    this.data.samples = this.componentSchema['x-code-samples'] || [];
  }
}
